import React from "react";

export default function DataPreview(props) {
  const { data } = props;
  return (
    <>
      <div className=" flex h-full  w-full items-center justify-center ">
        <div className=" h-[600px] w-[60%] overflow-y-auto rounded-lg bg-white p-6 ">
          <table className="  mx-auto   ">
            <thead className="border-b border-gray-300 text-start ">
              <th className="">Id</th>
              <th className="">Name</th>
              <th className="">Email</th>
            </thead>
            {data
              ? data.map((data, index) => {
                  if (index < 1000) {
                    return (
                      <tr
                        key={index}
                        className=" border-b  border-gray-300 font-thin"
                      >
                        <td>{data ? data.id : 1}</td>
                        <td>{data ? data.name : "john"}</td>
                        <td>{data ? data.email : "123@gmail.com"}</td>
                      </tr>
                    );
                  } else {
                    return null; // Returning null effectively skips rendering for the remaining items
                  }
                })
              : ""}
          </table>
        </div>
      </div>
    </>
  );
}
